import { render, staticRenderFns } from "./AboutPrivacy2.vue?vue&type=template&id=3ea9203f"
import script from "./AboutPrivacy2.vue?vue&type=script&lang=ts"
export * from "./AboutPrivacy2.vue?vue&type=script&lang=ts"
import style0 from "./AboutPrivacy2.vue?vue&type=style&index=0&id=3ea9203f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6.0_webpack@4.47.0___875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports